import { createFileRoute } from "@tanstack/react-router";
import { MovePage } from "@/modules/activity/presentation/pages/MovePage";

export const Route = createFileRoute("/_authenticated/move")({
  component: MovePage,
});

